module.exports = __webpack_public_path__ + "img/anewitem-headphones.d7152653.svg";